import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/auth/auth.service';

export interface SignalQueryParams {
    entity_type?: string,
    status?: string,
    project_type?: string,
    city?: string,
    county?: string,
    state?: string,
    country?: string,
    water_body?: string,
    oil_gas_basin?: string,
    ind_code?: string,
    sic_desc?: string,
    owners?: string,
    fuel?: string,
    unit_type?: string,
    content?: string,
    plant_name?: string,
    plant_id?: string,
    entity_name?: string,
    name?: string,
    mfg?: string
}

@Injectable({
    providedIn: 'root'
})
export class SignalAppService {

    constructor(private readonly authService: AuthService) {}

    private buildSignalUrl(token: string, sqp: SignalQueryParams): string {
        const queryObj = Object.fromEntries(Object.entries(sqp).filter(([, value]) => value != null));
        const params = new URLSearchParams(queryObj);
        return `${environment.signalSearchUrl}?jwt=${token}&${params.toString()}`;
    }

    public runSignalQuery(sqp: SignalQueryParams) {
        this.authService.getSignalToken().subscribe(token => {
            globalThis.open(this.buildSignalUrl(token, sqp), "signal");
        });
    }
}